import React from 'react';

/**
 * Single source of truth for loading spinners across the app.
 * Replaces ~12 inline copies that had drifted in size, tone, and a11y.
 */

const sizes = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-4',
  xl: 'w-16 h-16 border-4',
};

const tones = {
  blue: 'border-blue-400 border-t-transparent',
  red: 'border-red-400 border-t-transparent',
  gray: 'border-gray-400 border-t-transparent',
  white: 'border-white/40 border-t-transparent',
};

const Spinner = ({ size = 'md', tone = 'blue', className = '', label = 'Loading' }) => (
  <div
    className={`${sizes[size] || sizes.md} ${tones[tone] || tones.blue} rounded-full animate-spin ${className}`}
    role="status"
    aria-label={label}
  />
);

export default Spinner;
